<template lang="pug">
    .wrapper
        .modal-wrapper
            .icone-linha-info
            .text {{ menssagemModal }}

            vue-recaptcha(
              ref="recaptcha",
              :sitekey="recaptchaToken",
              @verify="logarColetorComRecaptcha",
              @expired="onCaptchaExpired"
            )

</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { logarColetorComTokenRecaptcha } from '../utils'
import config from '../../../config'
export default {
  name: 'RecaptchaModal',
  components: { VueRecaptcha },
  computed: {
    recaptchaToken () {
      return config.recaptchaToken
    },
    menssagemModal () {
      const rotasAposLoginColetor = ['sincronizador', 'marcacao', 'confirmacaoDados', 'confirmacaoPonto', 'historicoMarcacao', 'logout', 'clear']
      const nomeRotaAnterior = this.$store.state.rotaAnterior.name
      const nomeRotaAtual = this.$route.name

      const { cognitoInfo } = this.$store.state.accessData

      if (
        nomeRotaAtual === 'coletorPendente' ||
        (
          !nomeRotaAnterior &&
          cognitoInfo &&
          cognitoInfo.isSamlLogin
        )
      ) return this.$t('componentes.coletor.recaptcha.naoEhUmRobo')

      if (
        !nomeRotaAnterior ||
        nomeRotaAnterior === 'confirmacaoInfoColetor' ||
        rotasAposLoginColetor.includes(nomeRotaAnterior)
      ) return this.$t('componentes.coletor.recaptcha.sessaoExpirada')
      return this.$t('componentes.coletor.recaptcha.naoEhUmRobo')
    }
  },
  methods: {
    logarColetorComRecaptcha (token) {
      logarColetorComTokenRecaptcha(token)
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style scoped>
.wrapper {
    position: fixed;
    inset: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin: auto;
    padding: 1rem;
    border-radius: 10px;
    background-color: #EEEEEE;
    width: Min(90%, 400px);
    height: Min(90%, 300px);
}
.icone-linha-info {
  font-size: 5rem;
  color: var(--color-info);
}
.text {
    text-align: center;
    font-size: 1.1rem;
}

</style>
